/*
 * Hunt — shared NOTIFICATIONS BELL for the .topbar-right.
 *
 * The sounds SPA already renders its own bell (custom-scripts.js). This
 * standalone script gives the SAME bell to pages that do NOT load that bundle
 * (maps): it hydrates a bell into .topbar-right from /api/me + /api/me/
 * notifications, with a dropdown list, an unread badge, and mark-as-read on open.
 *
 * To avoid double-rendering on /sounds it NO-OPs whenever HUNT_ONLINE_ENABLED is
 * set (the sounds bundle owns the bell there). Anonymous users get no bell.
 *
 * Markup/classes match what the sounds bundle + styles.css already use
 * (.notif-wrap/.notif-bell/.notif-count/.notif-menu/.notif-list/.notif-item) so a
 * single stylesheet themes both. Built by esbuild → public/shared/notif-bell.js.
 */
import { notifText } from './notif-text.js';
import { detectLang } from './langs.js';

(function () {
	'use strict';

	// The sounds bundle owns the bell on /sounds — defer entirely there.
	if (window.HUNT_ONLINE_ENABLED) return;

	// --------------------------------------------------------------- i18n
	var lang = 'en', dict = null;
	(function () {
		var stored = null;
		try { stored = localStorage.getItem('language'); } catch (e) {}
		lang = detectLang(stored);
	})();
	function t(key, vars) {
		var val = null;
		// Prefer the dict already resolved by partials/i18n-client.php if present.
		var box = window.__I18N;
		var d = (box && box.dict) || dict;
		if (d) {
			var parts = key.split('.'), v = d;
			for (var i = 0; i < parts.length && v && typeof v === 'object'; i++) v = v[parts[i]];
			if (typeof v === 'string') val = v;
		}
		if (val == null) val = key;
		if (vars) Object.keys(vars).forEach(function (k) { val = val.replace(new RegExp('\\{' + k + '\\}', 'g'), String(vars[k])); });
		return val;
	}
	function loadDict() {
		if (window.__I18N && window.__I18N.dict) { dict = window.__I18N.dict; return Promise.resolve(); }
		return fetch((window.__I18N_URL || '/sounds/i18n/{lang}.json').replace('{lang}', lang))
			.then(function (r) { return r.ok ? r.json() : null; })
			.then(function (all) { if (all && all[lang]) dict = all[lang]; })
			.catch(function () {});
	}

	// --------------------------------------------------------------- helpers
	function esc(s) {
		return (s == null ? '' : String(s)).replace(/[&<>"]/g, function (c) {
			return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
		});
	}
	function timeAgo(iso) {
		if (!iso) return '';
		var ts; try { ts = new Date(iso).getTime(); } catch (e) { return ''; }
		if (isNaN(ts)) return '';
		var d = Date.now() - ts; if (d < 0) d = 0;
		var day = Math.floor(d / 86400000), h = Math.floor(d / 3600000), m = Math.floor(d / 60000);
		if (day >= 1) return t('time.days', { n: day });
		if (h >= 1)   return t('time.hours', { n: h });
		if (m >= 1)   return t('time.minutes', { n: m });
		return t('time.now');
	}

	// --------------------------------------------------------------- state
	var user = null, opened = false, built = false, modPending = 0;

	function fetchMe() {
		return fetch('/api/me', { credentials: 'include', headers: { Accept: 'application/json' } })
			.then(function (r) { return r.ok ? r.json() : null; })
			.then(function (b) { user = (b && b.user) || null; })
			.catch(function () { user = null; });
	}

	// --------------------------------------------------------------- render
	function bellSvg() {
		return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
			'<path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/></svg>';
	}

	function build() {
		var host = document.querySelector('.topbar-right');
		if (!host || document.getElementById('notifBell')) return;
		var wrap = document.createElement('div');
		wrap.className = 'notif-wrap';
		wrap.innerHTML =
			'<button type="button" class="notif-bell" id="notifBell" aria-haspopup="true" aria-expanded="false" title="' + esc(t('notif.title')) + '">' +
				bellSvg() + '<span class="notif-count" id="notifCount" hidden>0</span>' +
			'</button>' +
			'<div class="notif-menu" id="notifMenu">' +
				'<div class="notif-menu-head">' + esc(t('notif.title')) + '</div>' +
				'<div class="notif-list" id="notifList"><div class="notif-empty">' + esc(t('notif.loading')) + '</div></div>' +
			'</div>';
		// The language switcher usually sits at the far right; place the bell before it.
		host.insertBefore(wrap, host.firstChild);
		built = true;

		var btn = wrap.querySelector('#notifBell');
		btn.addEventListener('click', function (e) { e.stopPropagation(); toggleMenu(); });
		document.addEventListener('click', function (e) {
			var menu = document.getElementById('notifMenu');
			if (opened && menu && !wrap.contains(e.target)) closeMenu();
		});
		document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && opened) closeMenu(); });
	}

	function toggleMenu() { opened ? closeMenu() : openMenu(); }
	function openMenu() {
		var menu = document.getElementById('notifMenu'), btn = document.getElementById('notifBell');
		if (!menu) return;
		menu.classList.add('open'); if (btn) btn.setAttribute('aria-expanded', 'true');
		opened = true;
		// Opening clears the unread badge + marks read server-side (best-effort).
		// The moderation queue count is NOT a per-user notification, so it survives
		// mark-as-read — the badge keeps showing it until the queue is worked down.
		setCount(modPending);
		fetch('/api/me/notifications/read', { method: 'POST', credentials: 'include', headers: { Accept: 'application/json' } }).catch(function () {});
	}
	function closeMenu() {
		var menu = document.getElementById('notifMenu'), btn = document.getElementById('notifBell');
		if (menu) menu.classList.remove('open'); if (btn) btn.setAttribute('aria-expanded', 'false');
		opened = false;
	}

	function setCount(n) {
		var badge = document.getElementById('notifCount');
		if (!badge) return;
		if (n > 0) { badge.textContent = n > 9 ? '9+' : String(n); badge.removeAttribute('hidden'); }
		else badge.setAttribute('hidden', 'hidden');
	}

	// Map a notification row to { text, href }. Text comes from the shared
	// notifText() (single source); the href is bell-specific (full URLs here).
	function describe(n) {
		var href = null;
		var text = notifText(n, t);
		switch (n.type) {
			case 'map_changeset_approved':
			case 'map_changeset_partial':
			case 'map_changeset_rejected':
			case 'map_poi_rejected':       href = '/maps/'; break;
			case 'challenge_beaten':       if (n.challengeId) href = '/sounds/challenge/' + encodeURIComponent(n.challengeId); break;
			case 'achievement_unlocked':   href = '/u/' + encodeURIComponent((user && user.publicId) || ''); break;
			case 'loadout_invalid':
			case 'loadout_comment':
			case 'loadout_reply':
			case 'loadout_hidden':         if (n.data && /^[A-Za-z0-9]{12}$/.test(n.data.loadoutId || '')) href = '/loadouts/' + n.data.loadoutId; break;
		}
		return { text: text, href: href };
	}

	// A reviewer's pinned "X requests awaiting review" row — links to the admin
	// review queue. Lives at the TOP of the list, above the personal notifications.
	function modItemHtml() {
		if (modPending <= 0) return '';
		return '<a class="notif-item is-unread" href="/admin/maps">' +
			'<span class="notif-item-text">' + esc(t('notif.review_queue', { n: modPending })) + '</span></a>';
	}
	function renderList(items) {
		var list = document.getElementById('notifList');
		if (!list) return;
		var pinned = modItemHtml();
		if (!items.length && !pinned) { list.innerHTML = '<div class="notif-empty">' + esc(t('notif.empty')) + '</div>'; return; }
		list.innerHTML = pinned + items.map(function (n) {
			var info = describe(n);
			var cls = 'notif-item' + (n.read ? '' : ' is-unread');
			var when = timeAgo(n.createdAt);
			var inner = '<span class="notif-item-text">' + esc(info.text) + '</span>' +
				(when ? '<span class="notif-item-time" style="display:block;font-size:.72rem;color:var(--text-dim);margin-top:.15rem">' + esc(when) + '</span>' : '');
			return info.href
				? '<a class="' + cls + '" href="' + esc(info.href) + '">' + inner + '</a>'
				: '<div class="' + cls + '">' + inner + '</div>';
		}).join('');
	}

	function refresh() {
		return fetch('/api/me/notifications', { credentials: 'include', headers: { Accept: 'application/json' } })
			.then(function (r) { return r.ok ? r.json() : null; })
			.then(function (b) {
				if (!b) return;
				modPending = b.moderationPending || 0;
				setCount((b.unread || 0) + modPending);
				renderList(b.notifications || []);
			})
			.catch(function () {});
	}

	// --------------------------------------------------------------- boot
	function boot() {
		loadDict()
			.then(fetchMe)
			.then(function () {
				if (!user) return;        // anonymous → no bell
				build();
				if (built) refresh();
			})
			.catch(function () {});
	}

	if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
	else boot();

	// Re-localize labels if the language switches in-page (parity with menu-profile.js).
	window.addEventListener('hunt-lang-changed', function () {
		if (!built) return;
		var head = document.querySelector('#notifMenu .notif-menu-head');
		var btn = document.getElementById('notifBell');
		dict = (window.__I18N && window.__I18N.dict) || dict;
		if (head) head.textContent = t('notif.title');
		if (btn) btn.setAttribute('title', t('notif.title'));
		refresh();
	});
})();
